import { Suspense } from 'react';
import { HashRouter } from 'react-router-dom';

import { App } from './App';
import { AppProviders } from './AppProviders';
import i18nInstance from './i18n/i18n.config';
import { useLanguageSync } from './i18n/useLanguageSync';
import { BootLoading } from './layout/BootLoading';
import { ErrorBoundary } from './observability';

export function Root() {
  useLanguageSync(i18nInstance);

  // O boundary fica dentro da cadeia de providers, e não em volta dela: o aviso de erro
  // é traduzido e precisa do provider de i18next para renderizar.
  //
  // O `useTranslation` suspende até as traduções chegarem. Sem `<Suspense>`, uma suspensão
  // num render síncrono (a troca de hash do redirect pós-login é tratada com prioridade
  // discreta) vira erro, e o `ErrorFallback`, que também é traduzido, suspende de novo e
  // desmonta a raiz. O `<Suspense>` fica por fora do boundary para segurar também a
  // suspensão do próprio fallback.
  return (
    <AppProviders router={HashRouter}>
      <Suspense fallback={<BootLoading />}>
        <ErrorBoundary scope="app">
          <App />
        </ErrorBoundary>
      </Suspense>
    </AppProviders>
  );
}
